/**
 * VEYR reveal — single IntersectionObserver for [data-veyr-reveal].
 * Respects prefers-reduced-motion. Re-inits on Shopify section events.
 */
(function () {
  if (window.__veyrRevealInit) return;
  window.__veyrRevealInit = true;

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function revealAll(nodes) {
    nodes.forEach((node) => node.classList.add('is-revealed'));
  }

  function initReveal(root) {
    const scope = root || document;
    const nodes = scope.querySelectorAll('[data-veyr-reveal]:not(.is-revealed)');

    if (!nodes.length) return;

    if (prefersReducedMotion) {
      revealAll(nodes);
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
    );

    nodes.forEach((node) => observer.observe(node));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initReveal());
  } else {
    initReveal();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initReveal(event.target);
  });
})();
